module.exports = __webpack_public_path__ + "img/icon-best.56171c29.svg";